import React, {useState} from "react"
import NavigationMenuAddViewLeft from "./left/left"
import NavigationMenuAddViewRight from "./right/right"
import {AddView_OptionConfig, AddView_Group} from "./@types"
import VScroll from "../../gd-components/scrolling/custom-v-scroll/v-scroll"

type Props = {
    viewsStructure      : AddView_Group[]
    selectedGroupId?    : ID

    hidePopover         : func
}

// const debug = "AddViewContent"
const debug = false

export default function AddViewContent(props:Props) {

    const [selectedGroupId, setSelectedGroupId] = useState<ID>(props.selectedGroupId || props.viewsStructure[0].id!)
    const [selectedOption, setSelectedOption]   = useState<AddView_OptionConfig>()

    const hidePopover = () => {
        props.hidePopover()
        setSelectedGroupId(props.selectedGroupId || props.viewsStructure[0].id!)
    }

    const onSelectGroup = (group:AddView_Group) => {
        debug && console.log(debug, 'onSelectGroup', group)

        if (group.skipItemsList && group.items && !_.isEmpty(group.items)) {
            onSelectOption(group.items[0]!)
        } else {
            setSelectedGroupId(group.id!)
        }
    }

    const onSelectOption = (item:AddView_OptionConfig) => {
        debug && console.log(debug, 'onSelectItem', item)

        if (item?.onClick) {
            hidePopover()
            item.onClick()
        } else {
            setSelectedOption(item)
        }
    }

    const onBack = () => {
        debug && console.log(debug, 'onBack')
        setSelectedOption(undefined)
    }

    const selectedGroup = _.find(props.viewsStructure, group=>group.id === selectedGroupId)

    if (!selectedOption) {
        return (
            <>
                <NavigationMenuAddViewLeft viewsStructure   = {props.viewsStructure}
                                           selectedGroupId  = {selectedGroupId}
                                           onSelect         = {onSelectGroup}/>

                <NavigationMenuAddViewRight selectedGroup   = {selectedGroup!}
                                            onSelect        = {onSelectOption}
                                            hidePopover     = {hidePopover}/>
            </>
        )
    } else {

        if (selectedOption.formComponent) {
            return (
                <VScroll className="p-t-40" containerClass="p-l-25 p-t-10 p-r-25" style={{height: 'calc(100% - 40px)'}}>
                    <selectedOption.formComponent config        = {selectedOption}
                                                  hidePopover   = {hidePopover}
                                                  onBack        = {onBack}/>
                </VScroll>
            )
        } else {
            return (
                <div className="flex-row-center-center w-100-percent h-100-percent">
                    <div className="ui5-txt-default ui5-txt-red">selectedItem.formComponent is not defined
                    </div>
                </div>
            )
        }
    }
}